import React, { useState } from 'react';
import SafeIcon from '../common/SafeIcon';
import { FiZap, FiMail, FiAlertCircle, FiCheckCircle, FiArrowLeft } from 'react-icons/fi';
import { supabase } from '../supabase';

const ForgotPasswordPage = ({ onBack }) => {
  const [email, setEmail] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    const redirectTo = window.location.origin;

    const { error: resetError } = await supabase.auth.resetPasswordForEmail(
      email.trim(),
      { redirectTo }
    );

    setLoading(false);

    if (resetError) {
      setError(resetError.message);
      return;
    }

    setSent(true);
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-4" style={{ backgroundColor: '#F8FAFC' }}>
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-3 mb-7">
          <div className="w-10 h-10 rounded-xl flex items-center justify-center" style={{ background: 'linear-gradient(135deg,#2563EB,#38BDF8)', boxShadow: '0 4px 14px rgba(37,99,235,0.35)' }}>
            <SafeIcon icon={FiZap} className="text-white text-lg" />
          </div>
          <div className="leading-tight">
            <span className="text-xl font-black tracking-tight block" style={{ color: '#0F172A' }}>Fullpower</span>
            <span className="text-xs font-bold tracking-widest uppercase" style={{ color: '#2563EB' }}>LeadFlow</span>
          </div>
        </div>

        <div className="bg-white rounded-2xl p-8" style={{ border: '1px solid #E2E8F0', boxShadow: '0 4px 24px rgba(15,23,42,0.07)' }}>
          {sent ? (
            <div className="text-center space-y-4">
              <div className="flex justify-center">
                <div className="w-14 h-14 rounded-full flex items-center justify-center" style={{ backgroundColor: '#EFF6FF' }}>
                  <SafeIcon icon={FiCheckCircle} className="text-3xl" style={{ color: '#2563EB' }} />
                </div>
              </div>
              <h2 className="text-lg font-bold" style={{ color: '#0F172A' }}>Revisa tu correo</h2>
              <p className="text-sm" style={{ color: '#64748B' }}>
                Si existe una cuenta con <span className="font-semibold" style={{ color: '#0F172A' }}>{email}</span>, recibirás un enlace para restablecer tu contraseña.
              </p>
              <button
                onClick={onBack}
                className="w-full py-2.5 rounded-lg font-bold text-sm transition-all mt-2"
                style={{ backgroundColor: '#F1F5F9', color: '#334155' }}
                onMouseEnter={e => e.currentTarget.style.backgroundColor = '#E2E8F0'}
                onMouseLeave={e => e.currentTarget.style.backgroundColor = '#F1F5F9'}
              >
                Volver al inicio de sesión
              </button>
            </div>
          ) : (
            <>
              <button
                onClick={onBack}
                className="flex items-center gap-1.5 text-sm mb-5 font-medium transition-colors"
                style={{ color: '#64748B' }}
                onMouseEnter={e => e.currentTarget.style.color = '#0F172A'}
                onMouseLeave={e => e.currentTarget.style.color = '#64748B'}
              >
                <SafeIcon icon={FiArrowLeft} /> Volver
              </button>
              <h2 className="text-lg font-bold mb-1" style={{ color: '#0F172A' }}>¿Olvidaste tu contraseña?</h2>
              <p className="text-sm mb-6" style={{ color: '#94A3B8' }}>
                Ingresa tu correo y te enviaremos un enlace para restablecerla.
              </p>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div>
                  <label className="block text-xs font-bold uppercase tracking-wider mb-1.5" style={{ color: '#64748B' }}>
                    Correo electrónico
                  </label>
                  <div className="relative">
                    <SafeIcon icon={FiMail} className="absolute left-3 top-1/2 -translate-y-1/2 text-sm" style={{ color: '#94A3B8' }} />
                    <input
                      type="email"
                      required
                      className="w-full pl-9 pr-4 py-2.5 rounded-lg text-sm outline-none transition-all"
                      style={{ border: '1px solid #E2E8F0', color: '#0F172A', backgroundColor: '#F8FAFC' }}
                      placeholder="usuario@empresa.com"
                      value={email}
                      onChange={e => { setEmail(e.target.value); setError(''); }}
                      onFocus={e => { e.target.style.borderColor = '#2563EB'; e.target.style.backgroundColor = '#fff'; }}
                      onBlur={e => { e.target.style.borderColor = '#E2E8F0'; e.target.style.backgroundColor = '#F8FAFC'; }}
                    />
                  </div>
                </div>

                {error && (
                  <div className="flex items-center gap-2 px-3 py-2.5 rounded-lg text-sm" style={{ backgroundColor: '#FEF2F2', border: '1px solid #FECACA', color: '#EF4444' }}>
                    <SafeIcon icon={FiAlertCircle} className="text-base flex-shrink-0" />
                    {error}
                  </div>
                )}

                <button
                  type="submit"
                  disabled={loading}
                  className="w-full py-2.5 rounded-lg text-white font-bold text-sm transition-all disabled:opacity-70"
                  style={{ backgroundColor: '#2563EB', boxShadow: '0 2px 8px rgba(37,99,235,0.3)' }}
                  onMouseEnter={e => { if (!loading) e.currentTarget.style.backgroundColor = '#1D4ED8'; }}
                  onMouseLeave={e => e.currentTarget.style.backgroundColor = '#2563EB'}
                >
                  {loading ? 'Enviando…' : 'Enviar enlace'}
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPasswordPage;